/**
 * Speechmatics Speach to Text Languages - https://docs.speechmatics.com/introduction/supported-languages
 **/

export enum SpeechmaticsSTTLanguage {
  'Automatic' = 'auto',
  'Arabic' = 'ar',
  'Bashkir' = 'ba',
  'Basque' = 'eu',
  'Belarusian' = 'be',
  'Bengali' = 'bn',
  'Bulgarian' = 'bg',
  'Cantonese' = 'yue',
  'Catalan' = 'ca',
  'Croatian' = 'hr',
  'Czech' = 'cs',
  'Danish' = 'da',
  'Dutch' = 'nl',
  'English' = 'en',
  'Esperanto' = 'eo',
  'Estonian' = 'et',
  'Finnish' = 'fi',
  'French' = 'fr',
  'Galician' = 'gl',
  'German' = 'de',
  'Greek' = 'el',
  'Hebrew' = 'he',
  'Hindi' = 'hi',
  'Hungarian' = 'hu',
  'Indonesian' = 'id',
  'Interlingua' = 'ia',
  'Irish' = 'ga',
  'Italian' = 'it',
  'Japanese' = 'ja',
  'Korean' = 'ko',
  'Latvian' = 'lv',
  'Lithuanian' = 'lt',
  'Malay' = 'ms',
  'Maltese' = 'mt',
  'Mandarin' = 'cmn',
  'Marathi' = 'mr',
  'Mongolian' = 'mn',
  'Norwegian' = 'no',
  'Persian' = 'fa',
  'Polish' = 'pl',
  'Portuguese' = 'pt',
  'Romanian' = 'ro',
  'Russian' = 'ru',
  'Slovakian' = 'sk',
  'Slovenian' = 'sl',
  'Spanish' = 'es',
  'Swahili' = 'sw',
  'Swedish' = 'sv',
  'Tamil' = 'ta',
  'Thai' = 'th',
  'Turkish' = 'tr',
  'Ukrainian' = 'uk',
  'Urdu' = 'ur',
  'Uyghur' = 'ug',
  'Vietnamese' = 'vi',
  'Welsh' = 'cy',
}